var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 422,
    height: 54,
    viewBox: "0 0 422 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.22653 2.98464V47.4247H0.400391V2.98464H7.22653Z",
    fill: "url(#paint0_linear_626_3661)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M88.7128 2.98464V47.4247H81.8867V2.98464H88.7128Z",
    fill: "url(#paint1_linear_626_3661)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0459 30.9769V47.4255H39.4065V31.7705C39.4065 25.6681 36.0578 20.4292 29.4972 20.4292C23.0736 20.4292 19.8618 25.6681 19.8618 31.7047V47.4255H13.2224V14.117H19.8618V16.8598C22.3889 15.1163 25.6132 14.117 29.4972 14.117C40.2116 14.1293 46.0459 21.5559 46.0459 30.9769Z",
    fill: "url(#paint2_linear_626_3661)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M69.188 2.34715C60.4198 2.34715 55.0792 8.58118 55.0792 16.0118V17.8047H48.8548V23.3726H55.0792V47.4246H61.7186V23.3726H70.1963V17.8047H61.6979V15.8803C61.6979 11.2376 64.1877 8.11651 70.2627 8.11651C72.4116 8.09273 74.5386 8.5466 76.4872 9.44473V3.22304C74.1025 2.61994 71.649 2.32553 69.188 2.34715Z",
    fill: "url(#paint3_linear_626_3661)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M119.461 30.4316V14.8054H126.101V31.2541C126.101 40.675 120.345 48.1139 110.034 48.1139C99.8628 48.1139 94.1031 40.6215 94.1031 31.2006V14.8054H100.743V30.5056C100.743 36.4765 104.025 41.7154 110.046 41.7154C116.113 41.7154 119.461 36.4765 119.461 30.4316Z",
    fill: "url(#paint4_linear_626_3661)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M132.096 30.9784C132.096 21.6273 138.856 13.9993 148.695 13.9993C158.604 13.9993 164.762 21.0968 164.762 30.1806V32.837H138.524C139.258 38.409 143.541 42.3197 149.433 42.3197C153.45 42.3197 157.064 40.5967 159.006 37.015L164.09 39.6015C161.214 45.1735 155.927 48.1589 149.5 48.1589C139.528 48.1589 132.096 40.9956 132.096 30.9784ZM158.135 28.5892C157.865 23.4161 154.052 19.9002 148.628 19.9002C143.072 19.9002 139.458 23.7492 138.789 28.5892H158.135Z",
    fill: "url(#paint5_linear_626_3661)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M203.571 30.9769V47.4255H196.931V31.7705C196.931 25.6681 193.587 20.4292 187.026 20.4292C180.598 20.4292 177.387 25.6681 177.387 31.7047V47.4255H170.747V14.117H177.387V16.8722C179.914 15.1327 183.142 14.1293 187.026 14.1293C197.749 14.1293 203.571 21.5559 203.571 30.9769Z",
    fill: "url(#paint6_linear_626_3661)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M209.579 38.6543L215.351 35.8868C217.09 39.7317 220.903 41.7878 226.194 41.7878C231.414 41.7878 235.431 39.3205 235.431 34.9575C235.431 30.0476 230.866 29.2004 225.592 28.193C218.828 26.8647 210.463 24.6771 210.463 15.2561C210.463 7.89537 217.222 2.3234 225.725 2.3234C232.551 2.3234 238.643 5.50621 241.319 11.6086L235.63 14.5283C233.813 10.8767 230.397 8.63556 225.443 8.63556C220.878 8.63556 217.21 11.2879 217.21 15.0711C217.21 19.8453 221.961 20.9062 227.385 21.9672C234.078 23.2954 242.245 25.4831 242.245 34.904C242.245 42.7171 235.215 48.1698 226.181 48.1698C218.617 48.1575 212.259 44.7732 209.579 38.6543Z",
    fill: "url(#paint7_linear_626_3661)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M248.207 30.9784C248.207 21.6273 254.967 13.9993 264.806 13.9993C274.711 13.9993 280.869 21.0968 280.869 30.1806V32.837H254.631C255.369 38.409 259.652 42.3197 265.544 42.3197C269.557 42.3197 273.171 40.5967 275.113 37.015L280.201 39.6015C277.325 45.1735 272.034 48.1589 265.611 48.1589C255.635 48.1589 248.207 40.9956 248.207 30.9784ZM274.246 28.5892C273.976 23.4161 270.163 19.9002 264.739 19.9002C259.183 19.9002 255.568 23.7492 254.9 28.5892H274.246Z",
    fill: "url(#paint8_linear_626_3661)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M327.71 47.4233V28.055C327.71 20.1638 332.274 14.2587 340.831 14.2587C342.857 14.2312 344.866 14.638 346.719 15.4512V21.9526C345.111 21.0369 343.288 20.5562 341.433 20.5585C337.013 20.5585 334.337 23.544 334.337 28.3223V47.4233H327.71Z",
    fill: "url(#paint9_linear_626_3661)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M351.247 31.395C351.246 29.1646 351.688 26.9559 352.549 24.8952C353.41 22.8344 354.673 20.962 356.264 19.3851C357.856 17.8082 359.746 16.5577 361.825 15.705C363.905 14.8524 366.134 14.4143 368.385 14.4159C374.41 14.4159 379.962 17.1341 382.975 22.9733L377.489 26.0246C376.63 24.375 375.322 22.9971 373.713 22.0471C372.103 21.0972 370.258 20.6131 368.385 20.65C362.629 20.65 357.874 25.4941 357.874 31.395C357.874 37.3659 362.629 42.2758 368.385 42.2758C370.258 42.3126 372.103 41.8286 373.713 40.8786C375.322 39.9286 376.63 38.5507 377.489 36.9012L382.996 39.8866C379.983 45.7917 374.431 48.444 368.406 48.444C358.928 48.5756 351.247 40.816 351.247 31.395Z",
    fill: "url(#paint10_linear_626_3661)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M388.988 47.4255V0H395.628V18.5746C398.172 15.8524 402.122 14.1294 406.541 14.1294C416.181 14.1294 421.6 20.495 421.6 30.4464V47.4255H414.949V31.1085C414.949 25.3514 411.737 20.3634 405.512 20.3634C399.703 20.3634 395.603 25.006 395.603 31.31V47.4255H388.988Z",
    fill: "url(#paint11_linear_626_3661)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M304.152 13.9811C301.538 13.9822 298.957 14.5705 296.605 15.7018C294.253 16.833 292.19 18.4779 290.571 20.5127C288.952 22.5475 287.82 24.9193 287.259 27.4501C286.698 29.9808 286.723 32.6046 287.332 35.1244C287.941 37.6442 289.119 39.9943 290.776 41.9984C292.434 44.0024 294.528 45.6082 296.901 46.695C299.275 47.7819 301.866 48.3216 304.48 48.2736C307.095 48.2256 309.664 47.5911 311.995 46.4178L307.87 41.2242C305.703 42.0118 303.339 42.0937 301.122 41.458C298.904 40.8223 296.949 39.5022 295.541 37.6896C294.133 35.8771 293.345 33.6666 293.292 31.3796C293.238 29.0927 293.923 26.8486 295.245 24.9737C296.568 23.0989 298.46 21.691 300.645 20.9548C302.831 20.2187 305.196 20.1927 307.398 20.8806C309.599 21.5685 311.522 22.9345 312.886 24.7798C314.25 26.6252 314.985 28.8536 314.983 31.1412C314.986 33.3062 314.327 35.4213 313.091 37.2066L317.199 42.3879C319.381 39.9069 320.796 36.8559 321.275 33.5994C321.755 30.3429 321.278 27.0185 319.902 24.0232C318.527 21.0278 316.31 18.4882 313.517 16.7075C310.724 14.9268 307.473 13.9804 304.152 13.9811Z",
    fill: "url(#paint12_linear_626_3661)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M323.192 49.9372L317.984 54L311.983 46.4336C313.967 45.4268 315.736 44.054 317.199 42.3879L323.192 49.9372Z",
    fill: "url(#paint13_linear_626_3661)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_626_3661",
    x1: 4.99865,
    y1: 30.4616,
    x2: 421.6,
    y2: 30.4616,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0364583,
    stopColor: "#E4572E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#5A0DFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#120037"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_626_3661",
    x1: 4.99865,
    y1: 30.4616,
    x2: 421.6,
    y2: 30.4616,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0364583,
    stopColor: "#E4572E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#5A0DFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#120037"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_626_3661",
    x1: 4.99865,
    y1: 30.4616,
    x2: 421.6,
    y2: 30.4616,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0364583,
    stopColor: "#E4572E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#5A0DFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#120037"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_626_3661",
    x1: 4.99865,
    y1: 30.4616,
    x2: 421.6,
    y2: 30.4616,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0364583,
    stopColor: "#E4572E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#5A0DFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#120037"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_626_3661",
    x1: 4.99865,
    y1: 30.4616,
    x2: 421.6,
    y2: 30.4616,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0364583,
    stopColor: "#E4572E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#5A0DFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#120037"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_626_3661",
    x1: 4.99865,
    y1: 30.4616,
    x2: 421.6,
    y2: 30.4616,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0364583,
    stopColor: "#E4572E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#5A0DFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#120037"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_626_3661",
    x1: 4.99865,
    y1: 30.4616,
    x2: 421.6,
    y2: 30.4616,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0364583,
    stopColor: "#E4572E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#5A0DFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#120037"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_626_3661",
    x1: 4.99865,
    y1: 30.4616,
    x2: 421.6,
    y2: 30.4616,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0364583,
    stopColor: "#E4572E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#5A0DFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#120037"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_626_3661",
    x1: 4.99865,
    y1: 30.4616,
    x2: 421.6,
    y2: 30.4616,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0364583,
    stopColor: "#E4572E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#5A0DFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#120037"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_626_3661",
    x1: 4.99865,
    y1: 30.4616,
    x2: 421.6,
    y2: 30.4616,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0364583,
    stopColor: "#E4572E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#5A0DFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#120037"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_626_3661",
    x1: 4.99865,
    y1: 30.4616,
    x2: 421.6,
    y2: 30.4616,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0364583,
    stopColor: "#E4572E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#5A0DFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#120037"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_626_3661",
    x1: 4.99865,
    y1: 30.4616,
    x2: 421.6,
    y2: 30.4616,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0364583,
    stopColor: "#E4572E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#5A0DFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#120037"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_626_3661",
    x1: 4.99865,
    y1: 30.4616,
    x2: 421.6,
    y2: 30.4616,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0364583,
    stopColor: "#E4572E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#5A0DFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#120037"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_626_3661",
    x1: 4.99865,
    y1: 30.4616,
    x2: 421.6,
    y2: 30.4616,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0364583,
    stopColor: "#E4572E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#5A0DFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#120037"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.5f164cb67b42c61686d55aab267cb36b.svg";
export { ForwardRef as ReactComponent };